import './App.css';
import React from 'react';
import ColourChallengeCanvas from './colourchallengecanvas.tsx';
import { AbstractChallenge, weightedRandomNumber } from './abstractchallenge.tsx';
import { AbstractCanvasProps } from './abstractcanvas.tsx';
import { INGREDIENTS } from './getIngredients.ts';

interface ColourChallengeData {
  colors: string[];
}

class ColourChallenge extends AbstractChallenge<ColourChallengeData> {
  reloadButtonText(): string {
    return "Generate New Colour Challenge";
  }
  title() {
    return "Here's a Scrapbook Colour Challenge for you...";
  }
  canvas(props: AbstractCanvasProps<ColourChallengeData>) {
    return <ColourChallengeCanvas {...props} />;
  }

  getChallengeData(ingredients: INGREDIENTS): ColourChallengeData {
    return {colors: this.generateColourScheme(weightedRandomNumber({3:3, 4:5, 5:3}))};
  }

  

  generateColourScheme(noOfColours: number): string[] {
    let colours: string[] = [];
    let hVal = 0;
    let sVal = 0;
    let lVal = 0;

    let mainHVal = this.getRandomInt(360);
    let mainLVal = 30 + this.getRandomInt(50);
    let mainSVal = 40 + this.getRandomInt(60);
    let jitter = this.getRandomInt(5) + 5;
    console.log("Jitter = " + jitter);
    console.log(noOfColours, typeof noOfColours, noOfColours === 5, noOfColours === 4)
    if (noOfColours === 5) {
      console.log("5 cols")
      for (let i = 0; i < noOfColours; i++) {
        sVal = mainSVal + this.getRandomInt(10);
        lVal = mainLVal + jitter;
        console.log(i, i === 0, i === 2, i === 3, i === 4)
        if (i === 0) {
          hVal = mainHVal - 25 - jitter;
          lVal = mainLVal; //-(jitter);   
          console.log(0)             
        }
        else if (i === 2) {
          hVal = mainHVal + (30 + jitter);
          lVal = mainLVal + (jitter * 2) + 5;
          console.log(2)
        }
        else if (i === 3) {
          hVal = mainHVal - 120 - jitter;
          console.log(3)
        }
        else if (i === 4) {
          hVal = mainHVal + 120 + jitter;
          console.log(4)
        }
        else {
          hVal = mainHVal;
        }
        colours[i] = "hsl(" + hVal + ", " + sVal + "%, " + lVal + "%)";
        console.log(colours[i], i)
      }
    }
    else if (noOfColours === 4) {
      hVal = mainHVal;
      let whichMethod = this.getRandomInt(10);
      console.log("whichMethod = " + whichMethod)
      for (let i = 0; i < noOfColours; i++) {
        sVal = mainSVal + this.getRandomInt(10);
        lVal = mainLVal + this.getRandomInt(10);
        colours[i] = "hsl(" + hVal + ", " + sVal + "%, " + lVal + "%)";
        if (whichMethod < 4) {
          console.log("Rectangle Split 4 colours")
          if (i === 0 || i === 2) {
            hVal = hVal + 60 + this.getRandomInt(10);
          }
          else {
            hVal = hVal + 120 + this.getRandomInt(10);
          }
        }
        else if (whichMethod < 7) {
          console.log("Equal Split 4 colours")
          hVal = hVal + 90 + this.getRandomInt(10);
        }
        else {
          console.log("Similar 4 colours");
          hVal = hVal + this.getRandomInt(30) + 30;

        }
      }
    } else {
      for (let i = 0; i < noOfColours; i++) {
        sVal = mainSVal + this.getRandomInt(10);
        lVal = mainLVal + jitter;
        if (i === 0) {
          hVal = mainHVal - 25 - jitter;
          lVal = mainLVal; //-(jitter);                
        }
        else if (i === 2) {
          hVal = mainHVal + (30 + jitter);
          lVal = mainLVal + (jitter * 2) + 5;
        }
        else {
          hVal = mainHVal;
        }
        colours[i] = "hsl(" + hVal + ", " + sVal + "%, " + lVal + "%)";
        console.log(colours[i], i)
      }
    }
    return colours;
  }

}

export default ColourChallenge;
export type { ColourChallengeData };